import { PagedRequestDto } from '../paged-request.model';

// ====================================================================
// ENUMS
// ====================================================================

export enum InvoiceGroupStatus {
  Pending = 'Pending',
  PartiallyPaid = 'PartiallyPaid',
  Paid = 'Paid',
  Overdue = 'Overdue'
}

export enum PaymentStatus {
  Succeeded = 'succeeded',
  Processing = 'processing',
  RequiresAction = 'requires_action',
  Failed = 'failed'
}

// ====================================================================
// REQUEST DTOs
// ====================================================================

export interface InvoiceGroupSearchDto extends PagedRequestDto {
  status?: InvoiceGroupStatus | null;
}

export interface PayInvoiceGroupRequest {
  invoiceIds: string[];
}

// ====================================================================
// RESPONSE DTOs - Summary (for list endpoint)
// ====================================================================

export interface InvoiceGroupSummaryDto {
  id: string;
  referenceNumber: string;
  corporationId: string;
  weekStartDate: string;
  weekEndDate: string;
  status: InvoiceGroupStatus;
  invoiceCount: number;
  totalAmount: number;
  createdAt: string;
  updatedAt: string;
}

// ====================================================================
// RESPONSE DTOs - Detail (for detail endpoint)
// ====================================================================

export interface InvoiceGroupDetailDto extends InvoiceGroupSummaryDto {
  invoices: InvoiceGroupInvoiceDto[];
  paymentHistory: InvoicePaymentAttemptDto[];
}

export interface InvoiceGroupInvoiceDto {
  id: string;
  invoiceNumber: string;
  facilityId: string;
  facilityName: string;
  totalAmount: number;
  invoiceStatus:
    | 'Sent'
    | 'Viewed'
    | 'Overdue'
    | 'PartiallyPaid'
    | 'Paid'
    | 'Cancelled';
  stripePaymentStatus: string | null;
  isProcessing: boolean;
  dueDate: string;
  paidAt: string | null;
}

export interface InvoicePaymentAttemptDto {
  id: string;
  invoiceId: string;
  amount: number;
  attemptedAt: string;
  paymentMethodType: string | null;
  stripePaymentIntentId: string | null;
  status: string;
  failureReason: string | null;
}

// ====================================================================
// RESPONSE DTOs - Payment Result (for pay endpoint)
// ====================================================================

export interface PaymentAttemptResultDto {
  invoiceId: string;
  invoiceNumber: string;
  amount: number;
  status: PaymentStatus;
  paymentMethodType: string | null;
  stripePaymentIntentId: string | null;
  failureReason: string | null;
  checkoutRequired: boolean;
}

export interface InvoiceGroupPaymentResultDto {
  successes: PaymentAttemptResultDto[];
  processing: PaymentAttemptResultDto[];
  failures: PaymentAttemptResultDto[];
  groupStatus: InvoiceGroupStatus;
  checkoutRequired: boolean;
  message: string | null;
}

// ====================================================================
// ALIASES para compatibilidade
// ====================================================================

export type InvoiceGroupSearch = InvoiceGroupSearchDto;
export type InvoiceGroupSummary = InvoiceGroupSummaryDto;
export type InvoiceGroupDetail = InvoiceGroupDetailDto;
export type PaymentAttemptResult = PaymentAttemptResultDto;
export type InvoiceGroupPaymentResult = InvoiceGroupPaymentResultDto;
